export enum QuestionnaireMode {
  FILLING = 'filling',
  REVIEW = 'review'
}
